import React from 'react';
import { CgCPlusPlus } from "react-icons/cg";
import { FaReact, FaPython, FaGitAlt, FaGithub, FaNpm, FaFigma, FaBootstrap } from "react-icons/fa";
import { DiNodejs, DiJavascript1, DiJava } from "react-icons/di";
import { SiAndroid, SiFlutter, SiDart, SiKotlin, SiExpress, SiMongodb, SiPostman, SiVercel } from "react-icons/si";

const Skills = ({ skill }) => {
  const icon = {
    Android: <SiAndroid />,
    Flutter: <SiFlutter />,
    Java: <DiJava />,
    Kotlin: <SiKotlin />,
    Dart: <SiDart />,
    'C++': <CgCPlusPlus />,
    Postman: <SiPostman />,
    React: <FaReact />,
    Javascript: <DiJavascript1 />,
    NodeJs: <DiNodejs />,
    Express: <SiExpress />,
    MongoDb: <SiMongodb />,
    Git: <FaGitAlt />,
    Github: <FaGithub />,
    Npm: <FaNpm />,
    Figma: <FaFigma />,
    Bootstrap: <FaBootstrap />,
    Vercel: <SiVercel />
  }

  return (
    <div title={skill} className='SkillBox'>
      {icon[skill]}
    </div>
  )
}

export default Skills
